// extracted by mini-css-extract-plugin
export var adjacentSlide = "_r3-9";
export var arrowButtonContainer = "_r3-5";
export var arrowButtonIcon = "_r3-6";
export var carouselArrowButton = "_r3-2";
export var carouselElementContainer = "_r3-1";
export var currentSlide = "_r3-8";
export var left = "_r3-3";
export var otherSlide = "_r3-a";
export var productCarouselContainer = "_r3-0";
export var right = "_r3-4";
export var sliderOverflow = "_r3-7";